import React, { useContext, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import qmsDocumentTypeActions from "../../../_actions/_qmsActions/qmsDocumentTypeActions";
import { QmsDataEditModalContext } from "../_common/QmsDataTable";

export default function QmsAdminModal_EditDocumentType(props) {
  const { divisionId } = props;

  const qmsDataEditModal = useContext(QmsDataEditModalContext);

  const dispatch = useDispatch();

  const [label, setLabel] = useState(
    qmsDataEditModal.modalState.data && "label" in qmsDataEditModal.modalState.data
      ? qmsDataEditModal.modalState.data.label
      : ""
  );
  const [description, setDescription] = useState(
    qmsDataEditModal.modalState.data && "description" in qmsDataEditModal.modalState.data
      ? qmsDataEditModal.modalState.data.description
      : ""
  );
  const [formErrors, _setFormErrors] = useState({ label: null, description: null });
  const setFormError = (fieldName, message) =>
    _setFormErrors({ ...formErrors, [fieldName]: message });
  const clearFormError = (fieldName) =>
    _setFormErrors({ ...formErrors, [fieldName]: null });

  const validate = (fieldName) => {
    switch (fieldName) {
      case "label":
        if (!label) setFormError(fieldName, "Required");
        else clearFormError(fieldName);
        break;
      case "description":
        if (!description) setFormError(fieldName, "Required");
        else clearFormError(fieldName);
        break;
      default:
        break;
    }
    return;
  };

  const formIsInvalid = () => Object.values(formErrors).some((e) => e !== null);

  const handleClick_submit = async (e) => {
    e.preventDefault();
    const qmsDocType = {
      qmsDocumentTypeId: qmsDataEditModal.modalState.data
        ? qmsDataEditModal.modalState.data.qmsDocumentTypeId
        : 0,
      divisionId,
      label,
      description,
    };
    if (qmsDataEditModal.modalState.data)
      await dispatch(qmsDocumentTypeActions.update(qmsDocType));
    else await dispatch(qmsDocumentTypeActions.add(qmsDocType));
    qmsDataEditModal.toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={qmsDataEditModal.toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal
      isOpen={qmsDataEditModal.modalState.showModal}
      toggle={qmsDataEditModal.toggleModal}
      fade={false}
      size={"md"}
    >
      <ModalHeader
        toggle={qmsDataEditModal.toggleModal}
        className="bg-info text-white"
        close={closeBtn}
      >
        <FontAwesomeIcon
          icon={qmsDataEditModal.modalState.data ? "edit" : "plus"}
          className="fa-fw mr-2"
        />
        {qmsDataEditModal.modalState.data ? `Edit ` : `Add New `}
        Document Type
      </ModalHeader>
      <ModalBody>
        <div className="form-row form-group mb-2">
          <label htmlFor="label" className="col-sm-3 col-form-label">
            <b>Label:</b>*
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="label"
              id="label"
              className="form-control"
              maxLength="25"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              onBlur={(e) => validate(e.target.name)}
            />
            {formErrors.label && (
              <span className="error-small">
                <small>{formErrors.label}</small>
              </span>
            )}
          </div>
        </div>
        <div className="form-row form-group mb-2">
          <label htmlFor="make" className="col-sm-3 col-form-label">
            <b>Description:</b>*
          </label>
          <div className="col-sm-9">
            <textarea
              name="description"
              id="description"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onBlur={(e) => validate(e.target.name)}
            />
            {formErrors.description && (
              <span className="error-small">
                <small>{formErrors.description}</small>
              </span>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group mb-0">
          <button className="btn btn-primary" name="add" onClick={handleClick_submit}>
            {qmsDataEditModal.modalState.data ? "Update" : "Add"}
          </button>
          <button
            className="btn btn-secondary ml-2"
            color="secondary"
            onClick={qmsDataEditModal.toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
